<template>
    <router-link
        :to="to"
        class="
            inline-flex
            items-center px-1 pt-1
            border-b-2 border-transparent
            text-sm font-medium
            leading-5 text-gray-500
            hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700
            focus:border-gray-300 transition duration-150 ease-in-out"
    >
        {{ name }}
    </router-link>
</template>

<script>
export default {
    name: 'AdminLink',
    props: {
        to: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
    },
}
</script>

<style scoped>
.router-link-active {
    color: #009FB7 !important;
}
</style>